import * as PIXI from "pixi.js-legacy";

import CommanderBase from "../framework/src/commander/CommanderBase";
import events from "../framework/src/events/EventsObservable";
import States from "./States";

import InfoPages from "./InfoPages";
import TouchZone from "./TouchZone";
import NormalWin from "./NormalWin";
import IdleWin from "./IdleWin";
import BigWin from "./BigWin";
import BlinkAnimation from "./BlinkAnimation";
import WinCounter from "./WinCounter";
import Coins from "./Coins";
import StickingWild from "./StickingWild";
import Freespins from "./Freespins";

import { GAME_EVENTS } from "../framework/src/game/gameEvents";
import { WALLET_EVENTS } from "../framework/src/wallet/Wallet";
import { REELS_EVENTS } from "../framework/src/game/slot/reelsEvents";
import { CONFIG_PARAMS } from "../framework/src/system/SystemConfig";
import { pixiSetTimeoutAsync } from "../framework/src/engine/pixi/pixiTimeout";
import { STATES } from "../framework/src/states/states";
import SERVICE_IDENTIFIER from "../framework/src/constants/identifiers";
import IInfoPages from "../framework/src/engine/IInfoPages";
import GameFreespins from "../framework/src/game/GameFreespins";
import AddResult from "../framework/src/connect/result/AddResult";
import PixiApp from "../framework/src/engine/pixi/PixiApp";
import AbstractIframePage from "../framework/src/engine/AbstractIfarmePage";
import { infotexts } from "../assets/info/infotexts";

export default class Commander extends CommanderBase {
	slots: any;
	layers: any;

	freespins: GameFreespins;

	infopages: AbstractIframePage;
	paragraph: AbstractIframePage;
	TouchZone: TouchZone;
	BlinkAnimation: BlinkAnimation;
	WinCounter: WinCounter;
	Coins: Coins;
	NormalWin: NormalWin;
	IdleWin: IdleWin;
	BigWin: BigWin;
	StickingWild: StickingWild;
	Freespins: Freespins;

	lights: any;
	starCount: number;
	lineWinsIndex: number;
	skipAnim: boolean;
	fullPlate: boolean;

	result: AddResult;

	constructor(system, game, engine) {
		super(system, game, engine);
		this.slots = game.gameCore.slots;

		// @ts-ignore
		this.layers = this.app.layers.getAllLayers();

		// @ts-ignore
		window.com = this;
	}

	/**
	 * @override
	 */
	create(container) {
		super.create(container);
		// @ts-ignore
		this.freespins = this.game.freespins;
		this.freespins.setInFreeSpins(false);

		// @ts-ignore
		this.infopages = container.get<AbstractIframePage>(
			SERVICE_IDENTIFIER.InfoPages
		);
		this.infopages.create();
		// @ts-ignore
		this.paragraph = container.get<AbstractIframePage>(
			SERVICE_IDENTIFIER.ParagraphPage
		);
		this.paragraph.create();

		this.TouchZone = new TouchZone(
			this.config,
			this.layers,
			this.slots,
			this.wallet,
			this.symbols,
			this.infopages
		);
		this.BlinkAnimation = new BlinkAnimation(this);
		this.WinCounter = new WinCounter(this);
		this.Coins = new Coins(this);

		this.NormalWin = new NormalWin(this);
		this.IdleWin = new IdleWin(this);
		this.BigWin = new BigWin(this);

		this.StickingWild = new StickingWild(this);

		this.Freespins = new Freespins(this); // this.Freespins = animation,  this.freespins = CoreFreeSpins, behavior

		this.lights = undefined;
		this.starCount = 0;
		this.skipAnim = false;

		this.onInit();

		events.subscribe(
			GAME_EVENTS.GAME_ADD_FAIL_RESULT,
			(eventName, failResult) => this.failResult()
		);
	}

	/**
	 * @override
	 */
	setToStopSymbols() {}

	failResult() {
		this.StickingWild.hideJokers();
	}

	/**
	 * @override
	 */
	onInit() {
		this.initBackground();
		this.initStates();
		this.initReels();
		this.NormalWin.init();
		this.NormalWin.setLogo(this.layers.logo.children[0]);
		this.BigWin.init();
		this.BlinkAnimation.init();
		this.WinCounter.init();
		this.StickingWild.init();
		this.StickingWild.setWildMemory(
			this.config.getGameSpecifics(this.wallet.isBonus()).specialState.wildMemory
		);
		this.Freespins.init();

		for (let symbol of this.slots.reels.getSpinSymbols()) {
			Commander.unblurSymbol(symbol);
		}
	}

	/**
	 * @override
	 */
	onSpinStart() {
		this.lineWinsIndex = 0;
		this.fasterLights();
		this.TouchZone.hide();
		this.TouchZone.zonesOff();
		if (this.infopages.isOpen()) {
			this.infopages.close();
		}
		this.IdleWin.stop();

		if (this.freespins.isInFreeSpins()) {
			this.audio.playTrack("reel_Spin_FS");
			this.Freespins.drawFreespinRound();
			this.StickingWild.hideJokersFs();
			this.StickingWild.drawJokersFs();
		} else {
			this.audio.playTrack("reel_Spin");
			this.StickingWild.blueBackground();
			this.StickingWild.hideJokers();
			this.StickingWild.drawJokers();
		}
	}

	/**
	 * @override
	 */
	onUpdate() {}

	notify(eventName, data) {
		switch (eventName) {
			case WALLET_EVENTS.WALLET_ON_SET_BET:
				this.StickingWild.endFs(); // set alpha of jokers to 0
				this.TouchZone.updateBet();
				this.setStickingWildMemAfterFS()
				break;
		}

		super.notify(eventName, data);
	}

	setStickingWildMemAfterFS(){
		let mem = this.config.getGameSpecifics(this.wallet.isBonus())?.specialState.wildMemory
		if(!mem){ //fucky state
			// @ts-ignore
			mem = this.freespins._addResult[this.wallet.isBonus()? "getFSGameSpecifics":"getGameSpecifics"]().specialState.wildMemory
		}
		this.StickingWild.setWildMemory(mem);
	}

	onFreeSpins(result) {}

	/**
	 * @override
	 */
	controlResult(result) {
		// @ts-ignore
		this.audio.fadeOutTrack("bonus_Joker_Expand", 0.5);
		// @ts-ignore
		this.audio.stopTrack("reel_Spin");
		this.result = result;
		this.StickingWild.drawJokers();

		if (result.lineWins && result.lineWins.length) {
			this.onControlWin(result);
		} else {
			this.onControlNoWin();
		}
	}

	onControlWin(result) {
		if (result.lineWins[0] && result.lineWins[0].type === "freeSpins") {
			this.Freespins.run(result);
		} else {
			this.audio.playTrack("win_Bed_Start");
			this.NormalWin.shakeSymbols(result)
				.then((res) => {
					if (this.fullPlate) {
						return this.StickingWild.fullPlate();
					} else {
						return res;
					}
				})
				.then(() => {
					let oldWin = 0;
					if (this.freespins.isInFreeSpins()) {
						// @ts-ignore
						this.audio.fadeToTrack("bg_FreeSpins_Loop", 0.5, 1000);
						this.Freespins.hideCounter();
						result = this.freespins.getResult(this.freespins.getRoundIndex());
						oldWin = this.wallet.getWin();
					}

					this.audio.playTrack("win_Bed_Loop");
					this.audio.playTrack("win_Counter_Loop");

					if (this.isBigWin(result.win, oldWin)) {
						// @ts-ignore
						this.audio.fadeInPlaying("bwin_Coins_Loop", 1);
						this.BigWin.run(result, oldWin).then(() => {
							this.endRound();
						});
					} else {
						this.states.setState(STATES.SKIP);
						this.NormalWin.run(result, oldWin).then(() => {
							if (
								result.lineWins[this.lineWinsIndex] &&
								result.lineWins[this.lineWinsIndex].type === "freeSpins"
							) {
								this.Freespins.run(result);
							} else {
								this.endRound();
							}
						});
					}
				});
		}
	}

	onControlNoWin() {
		this.endRound();
	}

	onEndRoundRecalced(result) {
		this.slowerLights();
		this.starCount = 0;
		this.skipAnim = false;
		if (!this.freespins.isInFreeSpins()) {
			if (this.result.win > 0 && !this.game.isAutoRun()) {
				this.IdleWin.run(this.result);
			}
		}
		if (!this.result.getFreeSpinResults()) {
			
			this.setStickingWildMemAfterFS()
		}
		this.TouchZone.zonesOn();
		this.NormalWin.symbolTint(0xffffff);
	}

	async endFreespins(ended) {
		if (ended) {
			// @ts-ignore
			this.audio.fadeOutTrack("bg_FreeSpins_Loop", 1000);
			await pixiSetTimeoutAsync(1);
			await this.Freespins.end();
			// @ts-ignore
			this.audio.fadeOutTrack("bonus_Joker_Idle_Loop_FS", 0.2);
			this.StickingWild.setWildMemory(
				this.config.get(CONFIG_PARAMS.GAME_SPECIFICS).specialState.wildMemory
			);
		}
	}

	isBigWin(win, oldWin) {
		let factor = (win - oldWin) / this.wallet.getBet();
		return factor >= this.config.get(CONFIG_PARAMS.BIG_WIN_FACTOR);
	}

	skip() {
		if (this.skipAnim === false) {
			this.skipAnim = true;
			if (this.freespins.isInFreeSpins()) {
				// @ts-ignore
				this.audio.fadeToTrack("bg_FreeSpins_Loop", 1, 1000);
			}

			// @ts-ignore
			this.audio.stopTrack("win_Bed_Loop");
			this.audio.playTrack("win_Bed_Stop");
			// @ts-ignore
			this.audio.stopTrack("win_Counter_Loop");
			this.audio.playTrack("win_Counter_Stop");
		}
	}

	getSymbolFactor(name) {
		return this.config
			.get(CONFIG_PARAMS.SYMBOL_DEFINITION)
			.find((symbols) => symbols.name === name);
	}

	initBackground() {
		this.layers.background.addChild(
			Commander.getSprite("background_reels.png", 0, 0, { x: 0, y: 0 })
		);
		this.layers.reels_cover.addChild(
			Commander.getSprite("background_menu_mask.png", 0, -40, { x: 0, y: 0 })
		);
		this.layers.logo.addChild(
			Commander.getSprite("logo.png", 450, 0, { x: 0, y: 0 })
		);
		this.initLights();

		let style1 = new PIXI.TextStyle({
			dropShadow: true,
			align: "center",
			dropShadowBlur: 3,
			dropShadowDistance: 2,
			fill: ["#f7cc7d", "#ffdf55", "#fcb310", "#cc4e0c"],
			fontFamily: "Ubuntu-Bold",
			fontSize: 45,
			letterSpacing: -2,
		});
		let left40 = new PIXI.Text("40", style1);
		let right40 = new PIXI.Text("40", style1);
		left40.position.set(23, 300);
		right40.position.set(1208, 300);
		this.layers.reels_cover.addChild(left40, right40);

		let lang = infotexts[this.config.get("language")] ? this.config.get("language") : 'en'
		let txt = infotexts[lang]["texts"]["lines"];
		let style2 = new PIXI.TextStyle({
			dropShadow: true,
			align: "center",
			dropShadowBlur: 3,
			dropShadowDistance: 2,
			fill: ["#f7cc7d", "#ffdf55", "#fcb310", "#cc4e0c"],
			fontFamily: "Ubuntu-Bold",
			fontSize: txt.fontSize,
		});
		let leftLines = new PIXI.Text(txt.text, style2);
		leftLines.position.set(txt.x1, txt.y);
		let rightLines = new PIXI.Text(txt.text, style2);
		rightLines.position.set(txt.x2, txt.y);
		this.layers.reels_cover.addChild(leftLines, rightLines);
	}

	initLights() {
		this.lights = new PIXI.AnimatedSprite([
			PIXI.Texture.from("cover_02.png"),
			PIXI.Texture.from("cover_03.png"),
		]);
		this.lights.loop = true;
		this.slowerLights();
		this.layers.reels_cover.addChild(this.lights);
		this.lights.play();
	}

	fasterLights() {
		this.lights.animationSpeed = 0.15;
	}

	slowerLights() {
		this.lights.animationSpeed = 0.05;
	}

	initReels() {
		for (let r of this.slots.getReels()) {
			r.data = {
				joker: false,
				redJoker: false,
			};
		}
	}

	initStates() {
		let states = new States(this);
		events.subscribe(GAME_EVENTS.GAME_SPIN_START, () => this.onSpinStart());
		events.subscribe(GAME_EVENTS.GAME_END_ROUND_RECALCED, (eventName, data) =>
			this.onEndRoundRecalced(data)
		);
		events.subscribe(GAME_EVENTS.GAME_FREESPIN_END, (eventName, { ended }) =>
			this.endFreespins(ended)
		);

		events.subscribe(REELS_EVENTS.REEL_MOVE, (eventName, data) =>
			states.move.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_SPIN, (eventName, data) =>
			states.spin.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_BRAKEDOWN, (eventName, data) =>
			states.brakeDown.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_ACC_UP, (eventName, data) =>
			states.accUp.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_ACC_DOWN, (eventName, data) =>
			states.accDown.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_STOPPING, (eventName, data) =>
			states.stopping.call(this, data)
		);

		events.subscribe(WALLET_EVENTS.WALLET_ON_SET_BET, this);
	}

	static getSprite(name, x, y, anchor = { x: 0.5, y: 0.5 }) {
		let sprite = new PIXI.Sprite(PIXI.Texture.from(name));
		sprite.position.set(x, y);
		sprite.anchor.set(anchor.x, anchor.y);
		return sprite;
	}

	static removeTween(sprite) {
		createjs.Tween.removeTweens(sprite);
	}

	static blurSymbol(symbol) {
		symbol.texture = PIXI.Texture.from(
			symbol.name.replace("_blur", "") + "_blur.png"
		);
		return symbol;
	}

	static unblurSymbol(symbol) {
		symbol.texture = PIXI.Texture.from(
			symbol.name.replace("_blur", "") + ".png"
		);
		return symbol;
	}

	static removeSprite(sprite) {
		Commander.removeTween(sprite.scale);
		Commander.removeTween(sprite);
		if (sprite !== undefined && sprite.parent !== undefined) {
			sprite.parent.removeChild(sprite);
			sprite.destroy({ children: true, texture: false, baseTexture: true });
		}
	}

	static getTweenAsync(
		obj,
		to,
		time,
		eventL = () => {},
		ease = createjs.Ease.linear
	) {
		return new Promise<void>((res) => {
			Commander.removeTween(obj);
			let tween = createjs.Tween.get(obj)
				.to(to, time, ease)
				.call(() => {
					Commander.removeTween(obj);
					res();
				})
				.addEventListener("change", eventL);
		});
	}
}
